export const applyPendingAffiliateDisplayUser = (
  user,
  person,
  pendingAffiliateBandEnabled = false,
) => {
  if (!pendingAffiliateBandEnabled || !person?.pendingAffiliate) return user

  return { ...user, type: "PF", pendingAffiliate: true }
}
